import type { NextPage } from 'next';
import Link from 'next/link';
import { Page } from '../components';
import { useConstants } from '../hooks';
import PageContainer from '../components/PageContainer/PageContainer';


const SomePage: NextPage = () => {
  const {contacts: { phones, emails }} = useConstants();

  return (
    <Page title="Контакты">
      <PageContainer>
        <h2>Контакты</h2>

        <p>
          <Link href={`mailto:${emails.partner}`}>{emails.partner}</Link> – поставщикам и партнерам
          <br />
          <Link href={`mailto:${emails.sales}`}>{emails.sales}</Link> – покупателям
          <br />
          <Link href={`mailto:${emails.support}`}>{emails.support}</Link> – техническая поддержка
        </p>
        <p>
          Телефон: <Link href={`tel:${phones.main.phone}`}>{phones.main.label}</Link>
        </p>

        <h4>Реквизиты ООО "Все инженерные системы"</h4>
        <p>
          Общество с ограниченной ответственностью &quot;ВСЕ ИНЖЕНЕРНЫЕ СИСТЕМЫ&quot;
          <br/>
          ОГРН 1212700006551   ИНН 2722135025   КПП 272201001
          <br/>
          Р/счет 40702810407000010845
          <br/>
          ДАЛЬНЕВОСТОЧНЫЙ Ф-Л ПАО &quot;ПРОМСВЯЗЬБАНК&quot; г. Хабаровск
          <br/>
          БИК 040813744  К/cчет 30101810700000000744
          <br/>
          Юридический и фактический адрес:
          <br/>
          680011, г. Хабаровск, ул. Яшина, 33 – 10
        </p>
<br/>
        <h4>Реквизиты АО "Все инженерные системы"</h4>
        <p>
АКЦИОНЕРНОЕ ОБЩЕСТВО "ВСЕ ИНЖЕНЕРНЫЕ СИСТЕМЫ"
<br/>
ИНН: 9709101220 
<br/>
КПП: 770901001 
<br/>
Юр. Адрес: 109147, Г.Москва, ВНУТРИГОРОДСКАЯ ТЕРРИТОРИЯ ГОРОДА ФЕДЕРАЛЬНОГО ЗНАЧЕНИЯ МУНИЦИПАЛЬНЫЙ ОКРУГ ТАГАНСКИЙ, УЛ МАРКСИСТСКАЯ, Д. 20, СТРОЕНИЕ 8, ПОМЕЩ. 1/1
<br/>
Расчётный счёт: 40702810420000055032 
<br/>
ООО "Банк Точка" 
<br/>
БИК: 044525104 
<br/>
Корр. счёт: 30101810745374525104
</p>

      </PageContainer>
    </Page>
  );
};


export default SomePage;
